var map = {
	"../pages/addarticolo/addarticolo.module": [
		920,
		54
	],
	"../pages/addcapconsegna/addcapconsegna.module": [
		921,
		53
	],
	"../pages/addcategoria/addcategoria.module": [
		922,
		52
	],
	"../pages/addcategoriamenu/addcategoriamenu.module": [
		923,
		51
	],
	"../pages/addcoupon/addcoupon.module": [
		924,
		50
	],
	"../pages/addinforistorante/addinforistorante.module": [
		925,
		49
	],
	"../pages/addmanifesto/addmanifesto.module": [
		926,
		48
	],
	"../pages/addmenu/addmenu.module": [
		927,
		47
	],
	"../pages/addmenuscelta/addmenuscelta.module": [
		928,
		46
	],
	"../pages/addorario/addorario.module": [
		929,
		45
	],
	"../pages/addscelta/addscelta.module": [
		930,
		44
	],
	"../pages/addutente/addutente.module": [
		931,
		43
	],
	"../pages/articoli/articoli.module": [
		932,
		42
	],
	"../pages/capconsegna/capconsegna.module": [
		933,
		41
	],
	"../pages/categorie/categorie.module": [
		934,
		40
	],
	"../pages/categoriemenu/categoriemenu.module": [
		935,
		39
	],
	"../pages/commissione/commissione.module": [
		936,
		38
	],
	"../pages/coupon/coupon.module": [
		937,
		37
	],
	"../pages/editarticolo/editarticolo.module": [
		938,
		36
	],
	"../pages/editarticolosearch/editarticolosearch.module": [
		939,
		35
	],
	"../pages/editcapconsegna/editcapconsegna.module": [
		940,
		34
	],
	"../pages/editcategoria/editcategoria.module": [
		941,
		33
	],
	"../pages/editcategoriamenu/editcategoriamenu.module": [
		942,
		32
	],
	"../pages/editcoupon/editcoupon.module": [
		943,
		31
	],
	"../pages/editinfostore/editinfostore.module": [
		944,
		30
	],
	"../pages/editmenu/editmenu.module": [
		945,
		29
	],
	"../pages/editmenuscelta/editmenuscelta.module": [
		946,
		28
	],
	"../pages/editmenusearch/editmenusearch.module": [
		947,
		27
	],
	"../pages/editorario/editorario.module": [
		948,
		26
	],
	"../pages/editscelta/editscelta.module": [
		949,
		25
	],
	"../pages/editsconti/editsconti.module": [
		950,
		24
	],
	"../pages/edituser/edituser.module": [
		951,
		23
	],
	"../pages/edituserclient/edituserclient.module": [
		952,
		22
	],
	"../pages/editvalutazione/editvalutazione.module": [
		953,
		21
	],
	"../pages/inforistorante/inforistorante.module": [
		954,
		20
	],
	"../pages/menu/menu.module": [
		955,
		19
	],
	"../pages/menuscelte/menuscelte.module": [
		956,
		18
	],
	"../pages/messaggio/messaggio.module": [
		957,
		17
	],
	"../pages/notifica/notifica.module": [
		958,
		16
	],
	"../pages/orario/orario.module": [
		959,
		15
	],
	"../pages/ottimizza/ottimizza.module": [
		960,
		14
	],
	"../pages/resetpassword/resetpassword.module": [
		961,
		13
	],
	"../pages/ricerca/ricerca.module": [
		962,
		12
	],
	"../pages/ricercacoupon/ricercacoupon.module": [
		963,
		11
	],
	"../pages/ricercamenu/ricercamenu.module": [
		964,
		10
	],
	"../pages/ricercaordinazione/ricercaordinazione.module": [
		965,
		9
	],
	"../pages/ricercautenti/ricercautenti.module": [
		966,
		8
	],
	"../pages/ricercautenticlient/ricercautenticlient.module": [
		967,
		7
	],
	"../pages/scelte/scelte.module": [
		968,
		6
	],
	"../pages/sconti/sconti.module": [
		969,
		5
	],
	"../pages/utenti/utenti.module": [
		970,
		4
	],
	"../pages/utenticlient/utenticlient.module": [
		971,
		3
	],
	"../pages/valutazione/valutazione.module": [
		972,
		2
	],
	"../pages/viewordine/viewordine.module": [
		973,
		1
	],
	"../pages/viewordinericerca/viewordinericerca.module": [
		974,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 297;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 297
// module chunks = 55